import React, { useCallback } from 'react'
import { useAuthContext } from '../../AuthContext'
import { Box, Button, Icon, Link } from '@maui/elements'
import { useLocalStorage } from '@maui/hooks'
import { useFeatureFlag } from '../../hooks/useFeatureFlag'

export function FreemiumBanner() {
  const { hasPaidSubscription } = useAuthContext()
  const [visible, setVisible] = useLocalStorage('selectedFreemiumBannerVisibility', !hasPaidSubscription)
  const showBanner = useFeatureFlag('mati_freemium_deprecation_banner')

  const onDismiss = useCallback(() => {
    setVisible(false)
  }, [setVisible])

  if (!showBanner || hasPaidSubscription || !visible) return null

  return (
    <Box
      display="flex"
      alignItems="center"
      p="spacePaddingLarge"
      m="spaceGapLarge"
      mb="0"
      backgroundColor="colorTextMain"
      borderRadius="4px"
      gap="spaceGapMedium"
      color="colorTextReverse"
      fontSize="14px"
      minWidth="340px"
    >
      <Box flex="1"><b>Freemium will expire on February 14, 2024.</b> Contact us for a free trial.</Box>
      <Button
        as={Link}
        href="https://www.mandiant.com/contact-us"
        target="_blank"
        textTransform="unset"
        _hover={{
          textDecoration: 'none'
        }}
      >
        Contact us for a free trial
      </Button>
      <Icon name="times" role="close-icon" onClick={onDismiss} cursor="pointer" />
    </Box>
  )
}
